import { Navigate, Outlet, useLocation, useMatch } from 'react-router-dom'
import { useContext } from 'react'
import { AuthContextTsp } from 'lib/auth/AuthContext'

export function ProtectedRoutes() {
  const context = useContext(AuthContextTsp)
  const location = useLocation()
  const match = useMatch('/tempUrl/:projectId/:tempToken')
  const matchAllowSession = useMatch('/allowSession/:projectId')
  const matchLaunchExternalSession = useMatch(
    '/launchExternalSession/:projectId'
  )
  const projectId =
    match?.params.projectId ||
    matchAllowSession?.params.projectId ||
    matchLaunchExternalSession?.params.projectId

  if (!context) return 'Loading...'

  const { user } = context
  if (!user) {
    return (
      <Navigate
        to='/login'
        state={{
          from: location,
          projectId: projectId,
        }}
        replace
      />
    )
  }
  return <Outlet />
}
